import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store/index.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const routes = [
  {
    path: '/',
    name: 'website',
    component: () => import('@/views/website/index.vue')
  },
  {
    path: '/editor',
    name: 'editor',
    component: () => import('@/views/institution-management/editor.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/institution/choose-enterprise',
    name: 'chooseEnterprise',
    component: () => import('@/views/institution/choose-enterprise/list.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    children: [
      /**
       * 管理后台相关路由
       */
      {
        path: '/desc-template',
        name: 'descTemplate',
        component: () => import('@/views/institution-management/desc-template/list.vue'),
        meta: {
          name: '图文介绍'
        }
      },
      {
        path: '/desc-template/edit',
        name: 'descTemplate_edit',
        component: () => import('@/views/institution-management/desc-template/edit.vue'),
        meta: {
          name: '编辑图文'
        }
      },
      /**
       * 运营后台相关路由
       */
      {
        path: '/manage-institution-template',
        name: 'manageInstitutionTemplate',
        component: () => import('@/views/manage/institution-template/list.vue'),
        meta: {
          name: '企业模板'
        }
      },
      {
        path: '/manage-card-poster-template',
        name: 'manageCardPosterTemplate',
        component: () => import('@/views/manage/card-poster-template/list.vue'),
        meta: {
          name: '名片模板'
        }
      },
      {
        path: '/manage-desc-template',
        name: 'manageDescTemplate',
        component: () => import('@/views/manage/desc-template/list.vue'),
        meta: {
          name: '图文模板'
        }
      },
      {
        path: '/manage-desc-group-template',
        name: 'manageDescGroupTemplate',
        component: () => import('@/views/manage/desc-group-template/list.vue'),
        meta: {
          name: '图文组合模板'
        }
      },
      {
        path: '/manage-banner-group-template',
        name: 'manageBannerGroupTemplate',
        component: () => import('@/views/manage/banner-group-template/list.vue'),
        meta: {
          name: '宣传栏组合模板'
        }
      },
      {
        path: '/manage-goods-share-poster-template',
        name: 'manageGoodsSharePosterTemplate',
        component: () => import('@/views/manage/goods-share-poster-template/list.vue'),
        meta: {
          name: '商品海报模板'
        }
      },
      {
        path: '/manage-goods-share-msg-poster-template',
        name: 'manageGoodsShareMsgPosterTemplate',
        component: () => import('@/views/manage/goods-share-msg-poster-template/list.vue'),
        meta: {
          name: '商品消息模板'
        }
      },
      {
        path: '/manage-card-share-poster-template',
        name: 'manageCardSharePosterTemplate',
        component: () => import('@/views/manage/card-share-poster-template/list.vue'),
        meta: {
          name: '名片海报模板'
        }
      },
      {
        path: '/manage-card-share-msg-poster-template',
        name: 'manageCardShareMsgPosterTemplate',
        component: () => import('@/views/manage/card-share-msg-poster-template/list.vue'),
        meta: {
          name: '名片消息模板'
        }
      },
      {
        path: '/manage-article-share-poster-template',
        name: 'manageArticleSharePosterTemplate',
        component: () => import('@/views/manage/article-share-poster-template/list.vue'),
        meta: {
          name: '文章海报模板'
        }
      },
      {
        path: '/manage-article-share-msg-poster-template',
        name: 'manageArticleShareMsgPosterTemplate',
        component: () => import('@/views/manage/article-share-msg-poster-template/list.vue'),
        meta: {
          name: '文章消息模板'
        }
      },
      {
        path: '/manage-activity-share-poster-template',
        name: 'manageActivitySharePosterTemplate',
        component: () => import('@/views/manage/activity-share-poster-template/list.vue'),
        meta: {
          name: '表单海报模板'
        }
      },
      {
        path: '/manage-activity-share-msg-poster-template',
        name: 'manageActivityShareMsgPosterTemplate',
        component: () => import('@/views/manage/activity-share-msg-poster-template/list.vue'),
        meta: {
          name: '表单消息模板'
        }
      },
      {
        path: '/manage-marketing-msg-poster-template',
        name: 'manageMarketingMsgPosterTemplate',
        component: () => import('@/views/manage/marketing-msg-poster-template/list.vue'),
        meta: {
          name: '营销消息模板'
        }
      }
    ]
  },
  {
    path: '/:w*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 开启页面加载进度
  NProgress.start()
  next()
})

router.afterEach((to) => {
  matched(to.path)
  NProgress.done()
})

function matched (path) {
  const breadCrumb = []
  const route = routes.find(item => item.path === '/home').children
  route.forEach(item => {
    if (path.startsWith(item.path) && item.meta && item.meta.name) {
      breadCrumb.push({
        path: item.path,
        title: item.meta.name
      })
    }
  })
  store.commit('replaceBreadcrumb', breadCrumb)
}
export default router
